//
// Action Types
//
export const SET_SIDENAV_STATE = 'web-gallery/layout/SET_SIDENAV_STATE';

//
// Action Creators
//

export const setSideNavState = expanded => ({
  type: SET_SIDENAV_STATE,
  expanded,
});

//
// Thunks
//

export const sideNavToggle = () => (dispatch, getState) => {
  const { sideNavExpanded } = getState().galleries.layout;

  if (sideNavExpanded) {
    dispatch(setSideNavState(false));
  } else {
    dispatch(setSideNavState(true));
  }
};
